import { render, staticRenderFns } from "./Asidebar.vue?vue&type=template&id=3a4b1fc6&scoped=true"
import script from "./Asidebar.vue?vue&type=script&lang=js"
export * from "./Asidebar.vue?vue&type=script&lang=js"
import style0 from "./Asidebar.vue?vue&type=style&index=0&id=3a4b1fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4b1fc6",
  null
  
)

export default component.exports